import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

interface ColumnaClase {
  E21NUM: string;
  E21FEC: string;
}

interface EstudianteFila {
  M12CAR: string;
  M12NOM: string;
  Ausencias: { [E21NUM: string]: string };
}

interface TipoAusencia { value: string; label: string; }
interface ReporteDisponible { SYS10COD: string; SYS10DES: string; SYS21ICO: string; }
interface OpcionMes { value: string; label: string; }

@Component({
  selector: 'app-ausencias',
  templateUrl: './ausencias.component.html',
  styleUrls: ['./ausencias.component.scss']
})
export class AusenciasComponent implements OnInit {

  @Input() WsLlaves: any;
  @Output() cancelar = new EventEmitter<void>();

  private urlCargar  = 'api/ws/sap/Ausencias/CargarMatriz/regAusencias';
  private urlInsert  = 'api/ws/sap/E22ARC_WS/Insert/regAusencias';
  private urlDelete  = 'api/ws/sap/E22ARC_WS/Delete/regAusencias';
  private urlReporte = 'api/mantenimientos/VerReporte/';

  M05COD = '';
  M18COD = '';
  M19COD = '';
  M11COD = '';
  M23GRU = '';

  header: any = {};
  columnas: ColumnaClase[] = [];
  estudiantes: EstudianteFila[] = [];
  estudiantesAux: EstudianteFila[] = [];
  reportes: ReporteDisponible[] = [];
  permisos: any = { GRABAR: 'N' };

  tiposAusencia: TipoAusencia[] = [];
  tipoSeleccionado = 'A';

  meses: OpcionMes[] = [
    { value: '@',  label: '- Todos -' },
    { value: '1',  label: 'Enero' },
    { value: '2',  label: 'Febrero' },
    { value: '3',  label: 'Marzo' },
    { value: '4',  label: 'Abril' },
    { value: '5',  label: 'Mayo' },
    { value: '6',  label: 'Junio' },
    { value: '7',  label: 'Julio' },
    { value: '8',  label: 'Agosto' },
    { value: '9',  label: 'Setiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' }
  ];
  mesActual = '';

  buscaCarne = '';
  cargando = false;
  filaActiva = -1;

  // Evita doble click sobre la misma celda mientras se graba.
  private celdasEnProceso = new Set<string>();

  constructor(private dataService: SharedService) { }

  ngOnInit(): void {

    this.M05COD = this.WsLlaves[0].M05COD ;
    this.M18COD = this.WsLlaves[0].M18COD ;
    this.M19COD = this.WsLlaves[0].M19COD ;
    this.M11COD = this.WsLlaves[0].M11COD ;
    this.M23GRU = this.WsLlaves[0].M23GRU ;
    this.cargarMatriz();
  }

  cargarMatriz() {
    this.cargando = true;
    const body = {
      LLAVES: [{
        M05COD: this.M05COD, M18COD: this.M18COD, M19COD: this.M19COD,
        M11COD: this.M11COD, M23GRU: this.M23GRU, MES: this.mesActual
      }]
    };
    this.dataService.ConsultarWS(this.urlCargar, JSON.stringify(body)).subscribe(
      (resp: any) => {
        const d = resp.DATA || {};
        this.header = d.Header || {};
        this.columnas = d.Columnas || [];
        this.estudiantes = d.Estudiantes || [];
        this.estudiantesAux = JSON.parse(JSON.stringify(this.estudiantes));
        this.reportes = d.Reportes || [];
        this.permisos = d.Permisos || { GRABAR: 'N' };
        this.tiposAusencia = d.TiposAusencia || [];
        this.mesActual = d.MesActual || this.mesActual;
        // Se usan los valores que el backend resolvio para las llaves de grabado.
        this.M05COD = this.header.M05COD || this.M05COD;
        this.M18COD = this.header.M18COD || this.M18COD;
        this.M19COD = this.header.M19COD || this.M19COD;
        this.M11COD = this.header.M11COD || this.M11COD;
        this.M23GRU = this.header.M23GRU || this.M23GRU;
        this.cargando = false;
      },
      (err: any) => {
        this.cargando = false;
        Swal.fire('Error', err || 'No fue posible cargar la matriz de ausencias', 'error');
      });
  }

  cambiarMes(value: string) {
    this.mesActual = value;
    this.buscaCarne = '';
    this.cargarMatriz();
  }

  ausenciaDe(estudiante: EstudianteFila, col: ColumnaClase): string {
    return (estudiante.Ausencias && estudiante.Ausencias[col.E21NUM]) || '';
  }

  marcarFila(idx: number) {
    this.filaActiva = idx;
  }

  /** Click en celda: si esta vacia inserta con el tipo seleccionado; si tiene valor la elimina. */
  toggleAusencia(estudiante: EstudianteFila, col: ColumnaClase) {
    if (this.permisos.GRABAR !== 'S') return;
    const key = `${estudiante.M12CAR}_${col.E21NUM}`;
    if (this.celdasEnProceso.has(key)) return;

    const actual = this.ausenciaDe(estudiante, col);
    if (actual === '') {
      if (!this.tipoSeleccionado) {
        Swal.fire('Atención', 'Seleccione primero el tipo de ausencia a registrar', 'warning');
        return;
      }
      this.persistirInsert(estudiante, col, this.tipoSeleccionado, key);
    } else {
      this.persistirDelete(estudiante, col, actual, key);
    }
  }

  private persistirInsert(estudiante: EstudianteFila, col: ColumnaClase, tipo: string, key: string) {
    const body = {
      LLAVES: [{
        M05COD: this.M05COD, M18COD: this.M18COD, M19COD: this.M19COD,
        M11COD: this.M11COD, M23GRU: this.M23GRU,
        M12CAR: estudiante.M12CAR, E21NUM: col.E21NUM, E22EST: tipo
      }]
    };
    this.celdasEnProceso.add(key);
    estudiante.Ausencias[col.E21NUM] = tipo; // actualizacion optimista
    this.dataService.ConsultarWS(this.urlInsert, JSON.stringify(body)).subscribe(
      () => { this.celdasEnProceso.delete(key); },
      (err: any) => {
        this.celdasEnProceso.delete(key);
        estudiante.Ausencias[col.E21NUM] = ''; // revertir
        Swal.fire('Error', err || 'No fue posible registrar la ausencia', 'error');
      });
  }

  private persistirDelete(estudiante: EstudianteFila, col: ColumnaClase, previo: string, key: string) {
    const body = {
      LLAVES: [{
        M05COD: this.M05COD, M18COD: this.M18COD, M19COD: this.M19COD,
        M11COD: this.M11COD, M23GRU: this.M23GRU,
        M12CAR: estudiante.M12CAR, E21NUM: col.E21NUM
      }]
    };
    this.celdasEnProceso.add(key);
    estudiante.Ausencias[col.E21NUM] = ''; // actualizacion optimista
    this.dataService.ConsultarWS(this.urlDelete, JSON.stringify(body)).subscribe(
      () => { this.celdasEnProceso.delete(key); },
      (err: any) => {
        this.celdasEnProceso.delete(key);
        estudiante.Ausencias[col.E21NUM] = previo; // revertir
        Swal.fire('Error', err || 'No fue posible eliminar la ausencia', 'error');
      });
  }

  buscarCarne(event: any) {
    if (event.keyCode !== 13) return;
    const q = (event.target.value || '').toString().trim();
    if (!q) {
      this.estudiantes = JSON.parse(JSON.stringify(this.estudiantesAux));
      return;
    }
    this.estudiantes = this.estudiantesAux.filter(
      e => e.M12CAR.includes(q) || (e.M12NOM || '').toLowerCase().includes(q.toLowerCase())
    );
  }

  imprimirReporte(rep: ReporteDisponible) {
    const body = {
      LLAVES: [{
        SYS10COD: rep.SYS10COD,
        M05COD: this.M05COD, M18COD: this.M18COD, M19COD: this.M19COD,
        M11COD: this.M11COD, M23GRU: this.M23GRU
      }]
    };
    this.dataService.ConsultarWS(this.urlReporte, JSON.stringify(body)).subscribe(
      (resp: any) => {
        const base64 = resp?.DATA;
        if (!base64) {
          Swal.fire('Atención', 'El reporte no devolvió contenido', 'warning');
          return;
        }
        const link = document.createElement('a');
        link.href = 'data:application/pdf;base64,' + base64;
        link.target = '_blank';
        link.click();
      },
      (err: any) => Swal.fire('Error', err || 'No fue posible generar el reporte', 'error'));
  }

  emitirCancelar() {
    this.cancelar.emit();
  }
}
